import { CommonService } from './../../../../providers/common.service';
import { Component, Input, OnChanges, OnInit, SimpleChanges,Output,EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { HttpHeaders} from "@angular/common/http";
import { AuthService } from "../../../../providers/auth.service";
@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.scss']
})
export class PaymentStatusComponent implements OnInit {
  @Input() isLoading= false;
  @Input() isAchAdded: string = '';
  @Input() isEmail;
  @Input() paymentMode = '';
  @Input() amount;
  @Input() isPhoneNumber;
  @Input() transactionType;
  @Input() status?;
  @Input() errorMessage?;
  @Input() content;
  @Input() paymentLink;
  @Input() issurcharge = false;
  @Input() isTCDF = false;
  @Input() isDCDF = false;
  @Input() savedAmt;
  @Input() customLabel = "Surcharge";
  @Input() paymentFailureText = false;
  @Input() isFortellisEnabled = false;
  @Input() isFortellisProcessed: boolean = false;
  @Input() fortSuccessMessage: string;
  @Input() customField = {
    isRespMessage:""
  }
  // @Input() error;
  @Input() validateCard;
  @Input() isL2L3Loading: boolean = false

  @Input() isL2L3Applicable: boolean = false
  @Input() isL2L3Error: boolean = false
  @Input() L2L3ErrorMessage: string = 'Something wrong !'

  @Input() isLineItemEnabled: boolean = false;
  @Input() isLineItemProcessed: boolean = false;
  @Input() isLineItemError: boolean = false;
  @Input() lineItemErrorMessage: string = "Something wrong !"
  @Input() qbSuccessMessage: string = 'Successfully uploaded Quick Book details !';
  // External API invoices: invoice update status shown under the Approved result
  /** True when the popup was opened to generate a payment link (not to take a payment). */
  @Input() isPaymentLinkRequest: boolean = false;
  @Input() isExternalInvoiceUpdate: boolean = false;
  @Input() isExternalInvoiceUpdated: boolean = false;
  @Input() isExternalInvoiceUpdateError: boolean = false;
  @Input() externalInvoiceUpdateErrorMessage: string = '';
  @Input() externalInvoiceTxnId: string = '';
  /** API invoices only: Close and the receipts wait while the invoice is still being updated (set by the payment page). */
  @Input() lockWhileInvoiceUpdating: boolean = false;

  @Input() transactionId: string | null = null;
  @Input() isAlter: boolean = false

  //

  @Input() isMfaEnabled = false;
  @Input() mfaData;
  @Input() mfaTitle;
  @Input() mfaContent;
  @Input() apiName;
  @Input() formData;
  @Input() showBackButton;
  @Input() isCashChange = false;
  @Input() cashChange;

  httpOptions={};
  @Input() tranasctionTimeout;
  @Output() afterSuccess = new EventEmitter<any>();
  @Output() onSuccessClose = new EventEmitter<void>();


  constructor(public activeModal: NgbActiveModal, private clipboard: Clipboard, private router: Router, 
    public commonService: CommonService, private authService: AuthService) { 
      if(this.tranasctionTimeout > 0){
        this.httpOptions =  {
          headers: new HttpHeaders({ 'Authorization': `Bearer ${this.authService.getUser.pgAccessToken}`, 'withCredentials':'false', timeout: `${this.tranasctionTimeout*1000}`})
        }
      }else{
          this.httpOptions = {
            headers: new HttpHeaders({ 'Authorization': `Bearer ${this.authService.getUser.pgAccessToken}`, 'withCredentials':'false'})
          }
      }
  }

  ngOnInit(): void {

  }

  get isExternalInvoiceUpdating(): boolean {
    return this.lockWhileInvoiceUpdating && this.isExternalInvoiceUpdate && !this.isExternalInvoiceUpdated && !this.isExternalInvoiceUpdateError;
  }

  /** Called when the user clicks the Close button. Emits onSuccessClose if the transaction was successful, then closes the modal. */
  onClose(): void {
    if (this.status === '00') {
      this.onSuccessClose.emit();
    }
    this.activeModal.close('close');
  }

  copyExternalInvoiceTxnId() {
    this.clipboard.copy(this.externalInvoiceTxnId);
  }

  copyLink(){
    this.clipboard.copy(this.paymentLink);
  }

  openViewReceipt(type: 'MC' | 'CC') {
    const url = `/view-receipt/${this.transactionId}/${type}?alter=${this.isAlter}&idType=transactionId`;
    window.open(url, '_blank');
  }

  afterSuccessVerifyOtp(res){
    this.afterSuccess.next(res)
  }

  onBack(event){
    this.activeModal.close()
  }

}
